import React from 'react';
import { Link } from 'react-router-dom';
import { FaGooglePlay, FaAppStoreIos, FaYoutube } from 'react-icons/fa';
import { ImHeadphones } from "react-icons/im";
import Const from '../../util/Constants';

import './Footer.css';
import './Style.css';

class Footer extends React.Component {

  static packages = [
    { lable: 'Starter', value: Const.PackageStarter },
    { lable: 'Growth', value: Const.PackageGrowth },
    { lable: 'Enterprise', value: Const.PackageEnterprise },
  ];

  render() {
    return (
      <section className="footer">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-10" style={{height:20}}>
              <ul className="list-unstyled d-flex flex-wrap">
                <li className="me-4 mb-2">
                  <p className="f-text d-flex align-items-center gap-3">
                    <ImHeadphones /> &nbsp;&nbsp;
                    <a
                      href="https://play.google.com/store/apps/details?id=com.orggencrm.dialer&pcampaignid=web_share"
                      target="_blank"
                      rel="noreferrer"
                      className="d-flex align-items-center gap-1"
                    >
                      Dailer   
                    </a>
                    <span> &nbsp;&nbsp;|&nbsp;&nbsp;</span>
                    <FaGooglePlay /> &nbsp;&nbsp;
                    <a
                      href="https://play.google.com/store/apps/details?id=com.orggencrm.realestate&pcampaignid=web_share"
                      target="_blank"
                      rel="noreferrer"
                      className="d-flex align-items-center gap-1"
                    >
                       Android   
                    </a>
                    <span> &nbsp;&nbsp;|&nbsp;&nbsp;</span>
                    <FaAppStoreIos />&nbsp;&nbsp;
                    <a
                      href="https://apps.apple.com/us/app/orggen-realestate/id6746205043"
                      target="_blank"
                      rel="noreferrer"
                      className="d-flex align-items-center gap-1"
                    >
                      iOS 
                      
                    </a>
                  </p>
                </li>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <li >
                  <p className="f-text">
                    <Link to="/logout">Logout</Link>
                  </p>
                </li>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <li >
                 <p className="f-text">Client Id: {this.props.user.client_id}</p>       
                </li>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <li >
                 <p className="f-text">User Id: {this.props.user.user_id} ({this.props.user.staff_name}){" "}</p>
                </li>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

                <li >
                  <p className="f-text m-0">
                    Package :{" "}
                      {Footer.packages.find(
                        (pack) => pack.value === this.props.user.package
                      ).lable}
                  </p>
                </li>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <li>
                  <p className="f-text m-0">
                  More Product :&nbsp;
                    <Link to="https://uat.d2k11atzdkxm4q.amplifyapp.com" target="_blank"rel="noreferrer">Books</Link>
                    &nbsp;|&nbsp;
                    <a
                      href="https://uat.dhs8j9jlv7fi6.amplifyapp.com/setting" target="_blank"rel="noreferrer"
                    >
                     HelpDesk
                    </a>
                     &nbsp;|&nbsp;
                      <a
                      href="https://hrms.orggenteam.com/" target="_blank"rel="noreferrer"
                    >
                     HRMS
                    </a>
                  </p>
                </li>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <li>
                 <p className="f-text">Support No. : +91-8104797220</p>
                </li>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <li>
                  <p className="f-text d-flex align-items-center">
                    <a
                      href="https://youtube.com/@orggencrm3813?si=Ma-9wqJ5aBOg70OF"
                      target="_blank"
                      rel="noreferrer"
                      className="d-flex align-items-center gap-1"
                    >
                      <FaYoutube color="#ffffff" size={18} />
                    </a>
                  </p>
                </li>
             </ul>
           </div>
            <div className="col-md-2">
              <div className="row">
                <div className="col-md-12 text-right">
                  <p className="f-text">
                    ©{new Date().getFullYear()} <a href="https://orggencrm.com/" target="_blank" rel="noreferrer"> OrgGen Technologies LLP.
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
export default Footer;